import { useConfigContext } from '@fe-core';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { enroll } from '@api/queries/selfreg';
import { QUERY_KEY } from './data/useSelfregSessionDetails';

export const useSelfregSessionEnrollment = ({
  sessionId,
}: {
  sessionId: string;
}) => {
  const { config } = useConfigContext();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      enroll({ baseUrl: config.apiUrls.ccapi as string, sessionId }),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY],
      });
    },
  });
};
